function multiPinLookup(canonicalName, alternatives) {
    alternatives = [...alternatives, canonicalName];
    return Object.fromEntries(alternatives.map((a) => [a, canonicalName]));
}
const USB_2 = {
    pins: {
        dp: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 7.5,
            controlled_impedance_pair: "data",
        },
        dn: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 7.5,
            controlled_impedance_pair: "data",
        },
    },
    pinLookup: {
        // D+ and D-
        "d+": "dp",
        "d-": "dn",
        dp: "dp",
        dn: "dn",
        dm: "dn",
        "data+": "dp",
        "data-": "dn",
        dp1: "dp",
        dn2: "dn",
        p: "dp",
        n: "dn",
        usb_dp: "dp",
        usb_dm: "dn",
    },
};
const USB_3 = {
    pins: {
        ...USB_2.pins,
        VBUS: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 15,
        },
        rxp: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 7.5,
            controlled_impedance_pair: "rx",
        },
        rxn: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 7.5,
            controlled_impedance_pair: "rx",
        },
        txp: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 7.5,
            controlled_impedance_pair: "tx",
        },
        txn: {
            controlled_impedance: 90,
            controlled_impedance_tolerance: 7.5,
            controlled_impedance_pair: "tx",
        },
    },
    pinLookup: {
        ...USB_2.pinLookup,
        // SSTX+ and SSTX-
        txp: "txp",
        txn: "txn",
        "tx+": "txp",
        "tx-": "txn",
        txm: "txn",
        sstxp1: "txp",
        sstxn1: "txn",
        "dptx+": "txp",
        "dptx-": "txn",
        "superspeed_tx+": "txp",
        "superspeed_tx-": "txn",
        // SSRX+ and SSRX-
        "rx+": "rxp",
        "rx-": "rxn",
        rxp: "rxp",
        rxn: "rxn",
        rxm: "rxn",
        ssrxp1: "rxp",
        ssrxn1: "rxn",
        "rx2+": "rxp",
        "rx2-": "rxn",
        "dprx2+": "rxp",
        "dprx2-": "rxn",
        "superspeed_rx2+": "rxp",
        "superspeed_rx2-": "rxn",
        // VBUS
        vbus: "VBUS",
    },
};
const HDMI = {
    pins: {
        data0: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            controlled_impedance_pair: "data0",
        },
        data1: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            controlled_impedance_pair: "data1",
        },
        data2: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            controlled_impedance_pair: "data2",
        },
        data3: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            controlled_impedance_pair: "data3",
        },
        clock: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            controlled_impedance_pair: "clock",
        },
    },
    pinLookup: {
        "data0+": "data0",
        "data0-": "data0",
        "data1+": "data1",
        "data1-": "data1",
        "data2+": "data2",
        "data2-": "data2",
        "data3+": "data3",
        "data3-": "data3",
        "d0+": "data0",
        "d0-": "data0",
        "d1+": "data1",
        "d1-": "data1",
        "d2+": "data2",
        "d2-": "data2",
        "d3+": "data3",
        "d3-": "data3",
        "in_d0+": "data0",
        "in_d0-": "data0",
        "in_d1+": "data1",
        "in_d1-": "data1",
        "in_d2+": "data2",
        "in_d2-": "data2",
        "in_d3+": "data3",
        "in_d3-": "data3",
        "out_d0+": "data0",
        "out_d0-": "data0",
        "out_d1+": "data1",
        "out_d1-": "data1",
        "out_d2+": "data2",
        "out_d2-": "data2",
        "out_d3+": "data3",
        "out_d3-": "data3",
        data0_p: "data0",
        data0_n: "data0",
        data1_p: "data1",
        data1_n: "data1",
        data2_p: "data2",
        data2_n: "data2",
        data3_p: "data3",
        data3_n: "data3",
        "tmds data0+": "data0",
        "tmds data0-": "data0",
        "tmds data1+": "data1",
        "tmds data1-": "data1",
        "tmds data2+": "data2",
        "tmds data2-": "data2",
        "tmds data3+": "data3",
        "tmds data3-": "data3",
        "tmds data 0+": "data0",
        "tmds data 0-": "data0",
        "tmds data 1+": "data1",
        "tmds data 1-": "data1",
        "tmds data 2+": "data2",
        "tmds data 2-": "data2",
        "tmds data 3+": "data3",
        "tmds data 3-": "data3",
        "tmds clock+": "data3",
        "tmds clock-": "data3",
        "tmds_d0+": "data0",
        "tmds_d0-": "data0",
        "tmds_d1+": "data1",
        "tmds_d1-": "data1",
        "tmds_d2+": "data2",
        "tmds_d2-": "data2",
        "tmds_d3+": "data3",
        "tmds_d3-": "data3",
        "tmds_ck+": "clock",
        "tmds_ck-": "clock",
        "d_in0+": "data0",
        "d_in0-": "data0",
        "d_in1+": "data1",
        "d_in1-": "data1",
        "d_in2+": "data2",
        "d_in2-": "data2",
        "d_in3+": "data3",
        "d_in3-": "data3",
        "clk+": "clock",
        "clk-": "clock",
        "clock+": "clock",
        "clock-": "clock",
        clock_p: "clock",
        clock_n: "clock",
        in_clkp: "clock",
        in_clkn: "clock",
        out_clkp: "clock",
        out_clkn: "clock",
    },
};
const MIPI = {
    pins: {
        data0: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "data0",
        },
        data1: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "data1",
        },
        data2: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "data2",
        },
        data3: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "data3",
        },
        data4: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "data4",
        },
        clock: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "clock",
        },
    },
    pinLookup: {
        "dp0+": "data0",
        "dp0-": "data0",
        "dp1+": "data1",
        "dp1-": "data1",
        "dp2+": "data2",
        "dp2-": "data2",
        "dp3+": "data3",
        "dp3-": "data3",
        "dp4+": "data4",
        "dp4-": "data4",
        data_p0: "data0",
        data_n0: "data0",
        data_p1: "data1",
        data_n1: "data1",
        data_p2: "data2",
        data_n2: "data2",
        data_p3: "data3",
        data_n3: "data3",
        data_p4: "data4",
        data_n4: "data4",
        "d0+": "data0",
        "d0-": "data0",
        "d1+": "data1",
        "d1-": "data1",
        "d2+": "data2",
        "d2-": "data2",
        "d3+": "data3",
        "d3-": "data3",
        "d4+": "data4",
        "d4-": "data4",
        "clk+": "clock",
        "clk-": "clock",
        clock_p: "clock",
        clock_n: "clock",
    },
};
const PCI_2 = {
    pins: {
        a2: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER7",
        },
        a3: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER7",
        },
        a5: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER6",
        },
        a6: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER6",
        },
        a14: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER5",
        },
        a15: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER5",
        },
        a17: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER4",
        },
        a18: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER4",
        },
        a11: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "REFCLK2",
        },
        a12: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "REFCLK2",
        },
    },
    pinLookup: {
        a2: "a2",
        a3: "a3",
        a5: "a5",
        a6: "a6",
        a14: "a14",
        a15: "a15",
        a17: "a17",
        a18: "a18",
        a11: "a11",
        a12: "a12",
    },
};
const PCI_3 = {
    pins: {
        a2: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER3",
        },
        a3: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER3",
        },
        a5: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER2",
        },
        a6: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER2",
        },
        a14: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER1",
        },
        a15: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER1",
        },
        a17: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER0",
        },
        a18: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "PER0",
        },
        a11: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "REFCLK3",
        },
        a12: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "REFCLK3",
        },
    },
    pinLookup: {
        a2: "a2",
        a3: "a3",
        a5: "a5",
        a6: "a6",
        a14: "a14",
        a15: "a15",
        a17: "a17",
        a18: "a18",
        a11: "a11",
        a12: "a12",
    },
};
const PCI_4 = {
    pins: {
        rxa0p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA0",
        },
        rxa0n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA0",
        },
        rxa1p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA1",
        },
        rxa1n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA1",
        },
        rxa2p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA2",
        },
        rxa2n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA2",
        },
        rxa3p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA3",
        },
        rxa3n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "RXA3",
        },
        tx0p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX0",
        },
        tx0n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX0",
        },
        tx1p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX1",
        },
        tx1n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX1",
        },
        tx2p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX2",
        },
        tx2n: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX2",
        },
        tx3p: {
            controlled_impedance: 85,
            controlled_impedance_tolerance: 10,
            controlled_impedance_pair: "TX3",
        },
    },
    pinLookup: {
        rxa0p: "rxa0p",
        rxa0n: "rxa0n",
        rxa1p: "rxa1p",
        rxa1n: "rxa1n",
        rxa2p: "rxa2p",
        rxa2n: "rxa2n",
        rxa3p: "rxa3p",
        rxa3n: "rxa3n",
        tx0p: "tx0p",
        tx0n: "tx0n",
        tx1p: "tx1p",
        tx1n: "tx1n",
        tx2p: "tx2p",
        tx2n: "tx2n",
        tx3p: "tx3p",
        tx3n: "tx3n",
    },
};
// Ethernet (802.3 4x-twisted-pair / RJ45-style)
// Values chosen per Workplace discussion here:
// [workplace-post/535089409111462](/docs/workplace/535089409111462.md)
const ETH802_3 = {
    pins: {
        txrx_ap: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_A",
        },
        txrx_an: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_A",
        },
        txrx_bp: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_B",
        },
        txrx_bn: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_B",
        },
        txrx_cp: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_C",
        },
        txrx_cn: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_C",
        },
        txrx_dp: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_D",
        },
        txrx_dn: {
            controlled_impedance: 100,
            controlled_impedance_tolerance: 15,
            positive_to_negative_skew_max: "5ps",
            pair_to_pair_skew_max: "1ns",
            controlled_impedance_pair: "TXRX_D",
        },
    },
    // TODO maybe we could share a bunch of matching (and configuration) code with the propertyInference.ts logic.
    pinLookup: {
        ...multiPinLookup("txrx_ap", ["txrx_a+", "bi_da+", "txdata+", "tx+", "txp", "tx1+", "tdp", "eth_tdp"]),
        ...multiPinLookup("txrx_an", ["txrx_a-", "bi_da-", "txdata-", "tx-", "txn", "tx1-", "tdn", "eth_tdn"]),
        ...multiPinLookup("txrx_bp", ["txrx_b+", "bi_db+", "rxdata+", "rx+", "rxp", "rx1+", "rdp", "eth_rdp"]),
        ...multiPinLookup("txrx_bn", ["txrx_b-", "bi_db-", "txdata-", "rx-", "rxn", "rx1-", "rdn", "eth_rdn"]),
        ...multiPinLookup("txrx_cp", ["txrx_c+", "bi_dc+"]),
        ...multiPinLookup("txrx_cn", ["txrx_c-", "bi_dc-"]),
        ...multiPinLookup("txrx_dp", ["txrx_d+", "bi_dd+"]),
        ...multiPinLookup("txrx_dn", ["txrx_d-", "bi_dd-"]),
    },
};
const EMPTY_PART_TYPE_LOOKUP = {
    pinLookup: {},
    pins: {},
};
export const PART_TYPE_TO_BUS_MAP = {
    "USB A": USB_3,
    "USB B": USB_3,
    "USB C": USB_3,
    HDMI: HDMI,
    Ethernet: ETH802_3,
    // TODO - fill out the rest of these once we've got all the properties mapped
    "PCIe x1": EMPTY_PART_TYPE_LOOKUP,
    "PCIe x2": EMPTY_PART_TYPE_LOOKUP,
    "PCIe x4": EMPTY_PART_TYPE_LOOKUP,
    "PCIe x8": EMPTY_PART_TYPE_LOOKUP,
    "PCIe x16": EMPTY_PART_TYPE_LOOKUP,
};
export const BUS_TYPE_TO_BUS_MAP = {
    "USB 2.0": USB_2,
    "USB 3.0": USB_3,
    HDMI: HDMI,
    "MIPI CSI": MIPI,
    "MIPI DSI": MIPI,
    "PCIe 2.0": PCI_2,
    "PCIe 3.0": PCI_3,
    "PCIe 4.0": PCI_4,
    Ethernet: ETH802_3,
    // TODO - fill out the rest of these once we've got all the properties mapped
    DDR2: EMPTY_PART_TYPE_LOOKUP,
    DDR3: EMPTY_PART_TYPE_LOOKUP,
    DDR4: EMPTY_PART_TYPE_LOOKUP,
    SPMI: EMPTY_PART_TYPE_LOOKUP,
};
//# sourceMappingURL=partMappings.js.map